import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationStore } from '@pflegix/authentication';

// eslint-disable-next-line  sonarjs/function-return-type
export const authenticatedContentGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);

  const store = inject(AuthenticationStore);

  if (!store['currentUser']()) {
    return router.createUrlTree(['/login']);
  }

  return true;
};
